var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loading-wrapper"},[_vm._m(0),_c('p',[_vm._v(" "+_vm._s(_vm.message ? _vm.message : 'Please wait...'))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loading"},[_c('div',{staticClass:"rect1"}),_c('div',{staticClass:"rect2"}),_c('div',{staticClass:"rect3"}),_c('div',{staticClass:"rect4"}),_c('div',{staticClass:"rect5"})])
}]

export { render, staticRenderFns }